<script>
import router from '@/router';
import { useMenuStore } from '@/stores/menu';

// 刷新页面时需要重置router
if (localStorage.getItem('routes')) {
  const menuStore = useMenuStore();
  menuStore.generateRoutes(JSON.parse(localStorage.getItem('routes') ?? ''), router);
}
</script>

<template>
  <router-view />
</template>
